$component-class: 'rating-type-2';

.#{$component-class} {
  border: var(--border-size-sm) solid var(--border-color-secondary);
  border-radius: var(--radius-size-md);
  background-color: var(--background-color-secondary);
  padding: var(--spacing-2xl);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-sm) var(--spacing-2xl);

  @include desktop {
    gap: var(--spacing-xl) var(--spacing-2xl);
  }

  .me-heading {
    font-family: $font-family-base;
    color: var(--text-color-primary);
    margin-bottom: var(--spacing-xs);
  }

  [slot='description'] {
    .me-text {
      font-family: $font-family-base;
      color: var(--text-color-primary);
      margin-bottom: 0;
    }
  }

  &__rating-summary {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--spacing-xs) var(--spacing-lg);
  }

  &__feedback-info {
    display: flex;
    align-items: flex-end;
    gap: var(--spacing-xs);
  }

  &__value {
    font-family: $font-family-base;
    color: var(--text-color-primary);

    @include text-style(2xl, lg, bold);
  }

  &__status {
    font-family: $font-family-base;
    color: var(--text-color-primary);

    @include text-style(md, md);

    padding-bottom: px-to-rem(2px);
  }

  &__stars-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--spacing-2xs);
  }

  &__stars {
    flex: 0 0 auto;
    display: flex;
    max-width: 115px; 

    @include desktop {
      max-width: 140px; 
    }
  }

  &__star {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    min-height: 24px;
    transition: fill 0.3s;
    color: var(--color-neutral-neutral-light);
    padding-right: var(--spacing-2xs);

    &--active {
      color: var(--color-system-warning);
    }

    &:hover {
      color: var(--color-system-warning);
    }

    &--disabled {
      pointer-events: none;
      cursor: default;
    }
  }

  &__votes {
    font-family: $font-family-base;
    color: var(--text-color-brand-primary);

    @include text-style(md, md, bold);
  }

  &__notification {
    position: absolute;
    left: 0;
    top: 100%;
    display: flex;
    align-items: center;
    gap: var(--spacing-2xs);
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s;

    &.is-visible {
      visibility: visible;
      opacity: 1;
    }
  }

  &__notification-icon {
    color: var(--color-system-success);

    @include size(16px);
  }

  &__notification-msg {
    color: var(--color-system-success);

    @include text-style(sm, md);
  }
}
